<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'用户编辑'"
      :visible.sync="dialogVisible"
      width="1120px"
      top="20px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="editParam" :rules="rules" label-width="220px">
        <div class="form_item">
          <el-form-item label="头像:" prop="portrait">
            <base-upload
              :cover="editParam.portrait"
              :key="editParam.portrait"
              :action="action"
              @successCallback="successCallback"
              :wSize="360"
              :hSize="360"
            ></base-upload>
          </el-form-item>
          <el-form-item label="背景图:" prop="background">
            <base-upload
              :cover="editParam.background"
              :key="editParam.background"
              :action="action"
              @successCallback="successCallback1"
              :wSize="360"
              :hSize="360"
            ></base-upload>
          </el-form-item>
        </div>
        <div class="form_item">
          <div>
            <el-form-item label="昵称:">
              <el-input v-model="editParam.name" size="small"></el-input>
            </el-form-item>
            <el-form-item label="VIP等级:" prop="vipLevel" v-if="false">
              <el-select
                v-model="editParam.vipLevel"
                size="small"
              >
                <el-option
                  v-for="item in vipLevelList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="VIP到期时间:" prop="vipExpireDate" v-if="false">
              <el-date-picker
                type="datetime"
                v-model="editParam.vipExpireDate"
                placeholder="选择日期时间"
                size="small"
                :disabled="!auth"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="城市:" prop="region">
              <el-input v-model="editParam.region" size="small"></el-input>
            </el-form-item>
            <el-form-item label="原创博主排序:" prop="originalSort">
              <el-input
                v-model.number="editParam.originalSort"
                size="small"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="VIP商品会员卡:" prop="vipProductLevel" v-if="false">
              <el-select
                v-model="editParam.vipProductLevel"
                size="small"
                placeholder="请选择会员卡"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in vipProductLevelList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="加金币:" v-if="false">
              <div style="display:flex; height: 42px; align-items: center;">
                <el-input
                  v-model.number="editParam.amount"
                  size="small"
                  :disabled="!auth"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  style="marginLeft: 5px;"
                  :disabled="!auth"
                  @click="addUserGold"
                  >确定</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="金币免费权益到期时间:" prop="goldVideoFreeExpire">
              <el-date-picker
                type="datetime"
                v-model="editParam.goldVideoFreeExpire"
                placeholder="选择日期时间"
                size="small"
                :disabled="!auth"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="手机号码:" prop="mobile">
              <el-input v-model="editParam.mobile" size="small"></el-input>
            </el-form-item>
            <el-form-item label="绑定银行卡名称:" prop="mobile">
              <el-input v-model="editParam.bankActName" size="small"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="form_item">
          <el-form-item label="是否工作室:" prop="isMadou">
            <el-select
                v-model="editParam.isMadou"
                size="small"
                placeholder="请选择是否工作室"
            >
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="个人简介:">
            <el-input
                type="textarea"
                v-model="editParam.summary"
                size="small"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form_item">
          <div>
            <el-form-item label="是否是大V:" prop="superUser">
              <el-select
                v-model="editParam.superUser"
                size="small"
                placeholder="请选择是否是大V"
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否官方认证:" prop="officialCert">
              <el-select
                v-model="editParam.officialCert"
                size="small"
                placeholder="请选择是否官方认证"
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item
                label="用户提现分成比例："
                prop="txDiscount"
                class="item"
            >
              <el-input  placeholder="请选择用户提现分成比例" v-model.number="editParam.txDiscount" size="small">
                <template #suffix>%</template>
              </el-input>
            </el-form-item>
            <el-form-item
              label="用户获得(1-扣税率)："
              prop="taxLevel"
              class="item"
            >
              <el-select
                v-model="editParam.taxLevel"
                size="small"
                placeholder="请选择视频扣税率"
              >
                <el-option label="70%" :value="0"></el-option>
                <el-option label="60%" :value="6"></el-option>
                <el-option label="50%" :value="5"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div>
          <el-form-item label="是否开启暗网权限:" prop="isMadou">
            <el-select
              v-model="editParam.isMadou"
              size="small"
              placeholder="请选择是否工作室"
            >
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="handleOK()"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import {validatorCutNumber} from "@/utils/validator";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      uid: "",
      dialogVisible: false,
      flag: false,
      auth: true,
      // 用户头像上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      editParam: {
        name: "",
        vipProductLevel: '',
        goldVideoFreeExpire: "",
        summary: "",
        vipLevel: "",
        // vipExpireDate: "",
        // amount: "",
        mobile: "",
        portrait: "",
        background: [],
        superUser: "",
        officialCert: "",
        isMadou: "",
        taxLevel: "",
        txDiscount: 20,
        region: "",
        bankActName: "",
        originalSort: "",
      },
      vipProductLevelList: [],
      vipLevelList: [
        { value: 0, label: "非VIP" },
        { value: 1, label: "VIP" },
        { value: 2, label: "超级VIP" },
      ],
      rules: {
        // vipLevel: [
        //   { required: true, message: "请输入VIP等级", trigger: "blur" },
        //   { type: "number", message: "vip等级必须为数字" },
        // ],
        // vipExpireDate: [
        //   { required: true, message: "请选择VIP到期时间", trigger: "blur" },
        // ],
        originalSort: [
          {
            pattern: /^([1-9]\d|\d)$/,
            message: "请输入0-99的数字",
            trigger: "blur",
          },
        ],
        amount: [
          { required: false, message: "请输入金币", trigger: "blur" },
          { type: "number", message: "金币必须为数字" },
          { validator: validatorCutNumber, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getVipProductLevelList();
    // this.auth = validatorAuthority();
  },
  methods: {
    getVipProductLevelList() {
      this.vipProductLevelList = [];
      API.getPruductList().then((res) => {
        if (res.code === 200) {
          this.vipProductLevelList = res.data.map((item) => ({
            value: item.id,
            label: item.productName,
          }));
          this.vipProductLevelList.push({
            value:-1,
            label:"积分兑换VIP"
          })
          this.vipProductLevelList.push({
            value:-2,
            label:"签到领取VIP"
          })
        }
      });
    },


    // 加金币
    addUserGold() {
      let params = {
        uid: this.uid,
        amount: this.editParam.amount,
      };
      API.addUserGold(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.$emit("goBack");
          } else {
            this.$message.error("操作失败!");
          }
          // this.handleClose();
        })
        .catch(() => {});
    },
    // 头像上传成功回掉
    successCallback(res) {
      this.editParam.portrait = res.data.coverImg;
    },
    successCallback1(res) {
      this.editParam.background = [res.data.coverImg];
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs["form"].resetFields();
    },
    // 确认修改
    handleOK() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.flag = true;
          this.submitEdit();
        } else {
          return false;
        }
      });
    },
    // 提交修改
    submitEdit() {
      let params = {
        uid: this.uid,
        vipLevel: parseInt(this.editParam.vipLevel),
        // vipExpireDate: this.editParam.vipExpireDate,
        goldVideoFreeExpire: this.editParam.goldVideoFreeExpire,
        // amount: this.editParam.amount,
        mobile: this.editParam.mobile ? this.editParam.mobile : "ZERO_VALUE",
        summary: this.editParam.summary,
        portrait: this.editParam.portrait,
        name: this.editParam.name,
        vipProductLevel: this.editParam.vipProductLevel,
        background: this.editParam.background,
        region: this.editParam.region,
        superUser: this.editParam.superUser,
        officialCert: this.editParam.officialCert,
        isMadou: this.editParam.isMadou,
        taxLevel: this.editParam.taxLevel,
        txDiscount: this.editParam.txDiscount || 20,
        bankActName: this.editParam.bankActName
          ? this.editParam.bankActName
          : undefined,
        originalSort:
          this.editParam.originalSort != ""
            ? this.editParam.originalSort
            : undefined,
      };
      API.editUser(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "用户信息修改成功",
              type: "success",
            });
            this.$emit("goBack");
          } else {
            this.$message.error("修改失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(row) {
      this.uid = row.uid;
      this.editParam.vipLevel = row.vipLevel;
      // if(row.vipExpireDate.indexOf('1970')!=-1)row.vipExpireDate = new Date()
      // this.editParam.vipExpireDate = row.vipExpireDate;
      this.editParam.goldVideoFreeExpire = row.goldVideoFreeExpire
      this.editParam.amount = 0;
      this.editParam.mobile = row.mobile;
      this.dialogVisible = true;
      this.editParam.name = row.name;
      this.editParam.summary = row.summary;
      this.editParam.vipProductLevel = row.vipProductLevel || '';
      this.editParam.portrait = row.portrait;
      this.editParam.background = row.background;
      this.editParam.superUser = row.superUser;
      this.editParam.officialCert = row.officialCert;
      this.editParam.isMadou = row.isMadou;
      this.editParam.taxLevel = row.taxLevel;
      this.editParam.txDiscount = row.txDiscount  || 20;
      this.editParam.region = row.region;
      this.editParam.bankActName = row.bankActName;
      this.editParam.originalSort = row.originalSort;
    },
  },
};
</script>

<style lang="scss">
.edit-video-box {
  .el-select,
  .el-textarea,
  .el-select > .el-input,
  .el-input {
    width: 100% !important;
  }
}
.form_item {
  display: flex;
}
.item .el-form-item__label {
  line-height: 20px !important;
}

/deep/ .el-form-item{
  margin-bottom: 10px!important;
}
</style>
